module.exports = __webpack_public_path__ + "img/logo_2.72f0d7fc.png";